import { Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Image = styled(Avatar)`
  background: none;
  border-radius: ${(p) => p.theme.spacing(0.5)};
  border: 1px solid ${(p) => p.theme.palette.primary[200]};
  width: ${(p) => p.theme.spacing(7.25)};
  height: ${(p) => p.theme.spacing(7.25)};
  border-radius: ${(p) => p.theme.spacing(1)};
`;
